import React from "react";
import Image from "@root/components/image";
import ResponsiveWrapper from "../_responsive-wrapper";
import Link from "@helpers/link";

const CategoryGrid = ({ items }) => {
    if (!items) return null;

    return (
        <ResponsiveWrapper className="category-grid">
            <div className="category-grid__inner">
                {items?.map((item) => (
                    <Link className="category-grid__item" to={item?.url} key={item?.title}>
                        <div className="category-grid__item-image-wrapper">
                            <div className="category-grid__item-image-ratio">
                                <Image className="category-grid__item-image" image={item?.image} />
                            </div>
                        </div>
                        <div className="category-grid__item-content">
                            <div className="category-grid__item-title">
                                {item?.title}
                            </div>
                            <div className="category-grid__item-subtitle">
                                {item?.subtitle}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </ResponsiveWrapper>
    );
};

export default CategoryGrid;
